import './index.less';

import logo from 'assets/img/logo.png';
import classNames from 'classnames';

type Props = {
  loading: boolean;
  fixed?: boolean;
  size?: 'large' | 'default';
};

export const RevxLoader = ({ loading, fixed, size }: Props) => {
  return (
    <>
      {loading && (
        <div className={classNames('app-loader', size, { fixed })}>
          <img src={logo} alt="" />
        </div>
      )}
    </>
  );
};
